import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <HomePage />
    </>
  );
}

export default App;
